// MODULE
export { InternationalPhoneModule } from './src/module';

// INTERFACE
export { Country } from './src/interface/country.interface';
export { CountryCode } from './src/interface/country-code.interface';
export { CountryLocale } from './src/interface/country-locale.interface';

// PIPE
export { CountryPipe } from './src/pipe/country.pipe';

// DIRECTIVE
export { OnlyNumberDirective } from './src/directive/only-number.directive';

// SERVICE
export { CountryService } from './src/service/country.service';
export { LocaleService } from './src/service/locale.service';

// COMPONENT
export { IntPhonePrefixComponent } from './src/component/int-phone-prefix/int-phone-prefix.component';
